module.exports = new __parcel__URL__("blademaster.22c09ca4.png").toString();